import { Component, OnInit,Renderer2,ElementRef,ViewChild  } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-team-performance',
  templateUrl: './team-performance.component.html',
  styleUrls: ['./team-performance.component.scss']
})
export class TeamPerformanceComponent extends BaseComponent implements OnInit {
  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;
  private chartInstances: { [key: string]: Chart } = {};
  items = [];
  chartData: number[]=[];
  chartLabel: string;
  colorIndex: number=0;
  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
 
  // };
  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 10,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
    constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService 
        ,private sanitizer: DomSanitizer
        ,private renderer: Renderer2
      )
      { 
        
        super();
      }

  ngOnInit(): void {
  }

GetRanDomId()
{
  return Math.floor(Math.random() * 10000000000) + 1;
}     
  CreateChartSelectedDateWise() {
    console.log("this.items",this.items);
    console.log("employee",this.items[0]["employee"])
    this.chartContainer.nativeElement.innerHTML = '';
      if (this.items.length > 0) {
        this.reportAnalyticsService.GetTeamPerformanceReport(
          this.items[0]["reportFromDate"],
          this.items[0]["reportToDate"],
          this.items[0]["period"],
          this.items[0]["year"],
          this.items[0]["month"],
          "TeamPerformanceReport",
          this.items[0]["employee"],
        ).subscribe(ress => {
          this.loaderService.hide();
          if (ress.successed) {
            const data = ress.data;
           
           // console.log("TOtal Report",data.teamPerformanceTotalReport.totalOrderOfEmployee);
            this.GetChartData(data.teamPerformanceTotalReport.totalOrderOfEmployee,data.teamPerformanceEmployeeReport,"canvasId1","Employee Performance");
            this.GetChartData(data.teamPerformanceTotalReport.totalOrderOfAuditEmployee,data.teamPerformanceAuditReport,"canvasId2","Audit Employee Performance");

            //console.log("data.teamPerformanceReturnReport",data.teamPerformanceReturnReport);
            this.GetChartData(data.teamPerformanceTotalReport.totalReturn,data.teamPerformanceReturnReport.teamPerformanceEmployeeReport ,"canvasId3","Orders Return");
            this.GetChartData("",data.teamPerformanceReturnReport.teamPerformanceAuditReport ,"canvasId4","sonali");

          }
          else {
            this.toastrAlertService.errorToastr(ress.errorMessage);
          }
        }, error => {
          this.loaderService.hide();
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        });
  
        this.items = [];
      }
  }

  GetChartData(_totalOrder: string, _reportTable:any,_canvasId:string,_reportName:string){
             // console.log("_totalOrder-",_totalOrder,"_canvasId- ",_canvasId);
      //console.log("_reportTable[0].subColumnName",_reportTable[0]);
              const canvasId = `chart-${_canvasId}`;
  
              
              // Create container div
              const box = this.renderer.createElement('div');
              this.renderer.addClass(box, 'dashboardContentBox');
  
              // Heading
               if(_canvasId!=="canvasId4"){
               // console.log("canvasId",canvasId);
                const heading = this.renderer.createElement('div');
                this.renderer.addClass(heading, 'dashboardContentBoxHeading');
                heading.innerHTML = _reportName;
                this.renderer.appendChild(box, heading);
               }

              // Body
              const body = this.renderer.createElement('div');
              this.renderer.addClass(body, 'dashboardContentBoxBody');
  
              if(_canvasId!=="canvasId4"){
              const order = this.renderer.createElement('div');
              this.renderer.addClass(order, 'status-card');
              order.innerHTML = `Total Order : ${_totalOrder}`;
              this.renderer.appendChild(body, order);
              }
              
              const canvas = this.renderer.createElement('canvas');
              canvas.setAttribute('id', canvasId);
              canvas.setAttribute('width', '400');
              canvas.setAttribute('height', '200');
              this.renderer.appendChild(body, canvas);

           
  
              this.renderer.appendChild(box, body);
              this.renderer.appendChild(this.chartContainer.nativeElement, box);
  
              // Prepare chart data
              const chartLabels: string[] = [];
              
              const datasets: any[] = [];

                const distinctUser = _reportTable.filter(
                  (_reportTable, i, arr) => 
                    arr.findIndex(t => t.userName === _reportTable.userName) === i
                );
  
               
                 distinctUser.forEach((item, id) => {
                     chartLabels.push(item.userName);
                 });
                if( _reportTable[0] !== undefined)
                {
                  if(_reportTable[0].subColumnName !== "undefined" && _reportTable[0].subColumnName !== null && _reportTable[0].subColumnName !== undefined){
                      
                      console.log(' if');
                      const distinctColumn = _reportTable.filter(
                        (_reportTable, i, arr) => arr.findIndex(t => t.columnName === _reportTable.columnName) === i
                      );
      
                      const distinctSubColumn = _reportTable.filter(
                      (_reportTable, i, arr) => 
                        arr.findIndex(t => t.subColumnName === _reportTable.subColumnName) === i
                      );  
                    
                      distinctColumn.forEach((itemYear, idxYear) => {
                        distinctSubColumn.forEach((itemMonth, idxMonth) => {
                          const chartValues: number[] = [];
        
                          distinctUser.forEach(impl => {
                            // console.log(" _data.serviceId", _data.serviceId,"itemYear.columnName ",itemYear.columnName
                            //   ,"itemMonth.subColumnName",itemMonth.subColumnName,"implementationName",impl);
                            const filteredData = _reportTable.find(item =>
                              //item.serviceId === _data.serviceId &&
                              item.columnName === itemYear.columnName &&
                              item.subColumnName === itemMonth.subColumnName &&
                              item.userName === impl.userName
                            );
                            console.log("filteredData",filteredData);
                            chartValues.push(filteredData ? filteredData.totalOrder : 0);
                            
                          });
        
                          datasets.push({
                            label: `${itemYear.columnName} ${itemMonth.subColumnName}`,
                            data: chartValues,
                            backgroundColor: this.chartService.getColors(datasets.length) // unique color per dataset
                          });
                        });
                      });
                  }
                  else if(_reportTable[0].columnName === "undefined" || _reportTable[0].columnName === undefined)
                  {
                       console.log(' else if');
                      const chartValues: number[] = [];
                        distinctUser.forEach((itemImpl, id) => {
                            const filteredData =_reportTable.filter(
                              item => item.userName === itemImpl.userName 
                            );
                          
                          //console.log(' year' ,itemyear.columnName," filteredData.length-",filteredData.length);
                            chartValues.push(filteredData.length>0 ? filteredData[0].totalOrder : 0 );
                        });
                    
                    console.log(' chartValues' ,chartValues);
                      datasets.push({
                          label: "DateRange",//this.items[0]["reportFromDate"]+" - " +this.items[0]["reportToDate"],
                          data: chartValues,
                          backgroundColor: this.chartService.getColors(1), // Different color per year
                        });
                  }
                  else
                  {
                    console.log(' else ');
                      const distinctColumn = _reportTable.filter(
                      (_reportTable, i, arr) => arr.findIndex(t => t.columnName === _reportTable.columnName) === i
                    );
                      distinctColumn.forEach((itemyear, idxYear) => {
                      const chartValues: number[] = [];
                        distinctUser.forEach((itemImpl, id) => {
                            const filteredData = _reportTable.filter(
                              item =>item.columnName===itemyear.columnName && 
                              item.userName === itemImpl.userName
                            );
                            console.log("filteredData",filteredData);
                            console.log(' year' ,itemyear.columnName," filteredData.length-",filteredData.length);
                            chartValues.push(filteredData.length>0 ? filteredData[0].totalOrder : 0 );
                        });
                    
          console.log(' chartValues' ,chartValues);
                      datasets.push({
                          label: itemyear.columnName,
                          data: chartValues,
                          backgroundColor: this.chartService.getColors(idxYear), // Different color per year
                        });
    
                      //console.log("chartValues",chartValues);
                  });
    
                  }                
                }
              
              console.log("datasets",datasets);

              
              if (this.chartInstances[canvasId]) {
                this.chartInstances[canvasId].destroy();
              }

              // Initialize Chart
              setTimeout(() => {
                const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
                
                if (ctx) {
                  this.chartInstances[canvasId] =new Chart(ctx, {
                    type: 'horizontalBar',
                    data: {
                      labels: chartLabels,
                      datasets: datasets
                    
                     },
                    options: this.barChartOptions
                  });
                }
              }, 100); // Slight delay to ensure DOM is ready
            //});
          
  }
  
   addItem(newItem: string) {     
    this.items.push(newItem);   
    this.CreateChartSelectedDateWise();
  }
}
